import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { User } from "oidc-client-ts";
import { useAuthStore } from "@/stores/authStore";
import { KeycloakSessionResponse } from "@/lib/services/types";
import userManager from "@/configs/userManager";

export const useAuthSync = () => {
  const oidc = useAuth();

  const setToken = useAuthStore((state) => state.setToken);

  const setIsAutoLoggedIn = useAuthStore((state) => state.setIsAutoLoggedIn);

  const hydrateAutoLoggedInSession = async (
    session: KeycloakSessionResponse
  ) => {
    try {
      const expires_at =
        Math.floor(Date.now() / 1000) + (session.expires_in || 18000);

      const user = new User({
        access_token: session.access_token,
        refresh_token: session.refresh_token,
        token_type: session.token_type,

        profile: {
          sub: "",
          iss: "",
          aud: "",
          exp: 0,
          iat: 0,
        },
        expires_at,
        scope: "openid profile email offline_access",
      });
      console.debug("Manually setting the user session...");
      await userManager.storeUser(user);
      setIsAutoLoggedIn(true);
      console.debug("Successfully stored the user session.");
    } catch (err) {
      console.error("Failed to manually set the user session", err);
      setIsAutoLoggedIn(false);
    }
  };

  useEffect(() => {
    if (oidc.user?.access_token) {
      setToken(oidc.user.access_token);
    } else {
      setToken(null);
    }
  }, [oidc.user, setToken]);

  return {
    ...oidc,
    isAutoLoggedIn: useAuthStore().getIsAutoLoggedIn(),
    hydrateAutoLoggedInSession,
    setIsAutoLoggedIn,
  };
};
